import React from "react";
import { platformState, uiState } from "@shared/states/uiStates";
import { Modal } from "@shared/modals/Modal";
import wards_043 from "./images/043_wards.jpg";
import framebar_045 from "./images/045_framebar.jpg";
import text_047 from "./images/047_text.jpg";
import pencil_108 from "./images/108_pencil.jpg";
import map_110 from "./images/110_map.jpg";
import changelog_114_1 from "./images/114_1.webp";
import changelog_114_2 from "./images/114_2.webp";
import { useSnapshot } from "valtio";

interface ChangelogModalProps {}

const ChangelogModal: React.FC<ChangelogModalProps> = (props) => {
	const platformSnap = useSnapshot(platformState);

	const handleClose = () => {
		uiState.modal = undefined;
	};

	if (platformSnap.platform === "desktop") {
		return null;
	}

	return (
		<Modal title={"Changelog"} onClose={handleClose}>
			<div className={"max-h-[500px] h-screen w-[500px] text-slate-50 relative"}>
				<div className={"absolute inset-0 overflow-y-auto flex flex-col gap-8"}>
					<div>
						<div className={"flex items-center gap-2 mb-2"}>
							<div className={"rounded-xl px-2 uppercase bg-emerald-600 text-sm"}>
								New
							</div>
							<h1 className={"font-bold text-2xl"}>Version 2.0</h1>
						</div>
						<ul className={"list-disc"}>
							<li className={"ml-8"}>
								App is now fully free. No more memberships.
							</li>
							<li className={"ml-8"}>
								Custom games are now available to import after connecting
								your riot account.
							</li>
							<li className={"ml-8"}>
								Removed Atakhan from the map and hopefully from our memory.
							</li>
						</ul>
					</div>
					<div>
						<div className={"flex items-center gap-2 mb-2"}>
							<div className={"rounded-xl px-2 uppercase bg-emerald-600 text-sm"}>
								New
							</div>
							<h1 className={"font-bold text-2xl"}>Version 1.1.4</h1>
						</div>
						<img
							src={changelog_114_1}
							alt={"Copy game link button in game summary"}
							className={
								"overflow-hidden rounded border border-black m-2 w-10/12 align-middle"
							}
						/>
						<img
							src={changelog_114_2}
							alt={"Copy game link context menu on the frames bar"}
							className={
								"overflow-hidden rounded border border-black m-2 w-10/12 align-middle"
							}
						/>
						<ul className={"list-disc"}>
							<li className={"ml-8"}>
								Added a button to copy a link to a game from the game summary view.
							</li>
							<li className={"ml-8"}>
								Right-click on the frames bar to copy a link to the game at the
								current time.
							</li>
						</ul>
					</div>
					<div>
						<div className={"flex items-center gap-2 mb-2"}>
							<h1 className={"font-bold text-2xl"}>Version 1.1.3</h1>
						</div>
						<ul className={"list-disc"}>
							<li className={"ml-8"}>
								You can now set structures state from the sidebar.
							</li>
						</ul>
					</div>
					<div>
						<div className={"flex items-center gap-2 mb-2"}>
							<h1 className={"font-bold text-2xl"}>Version 1.1.2</h1>
						</div>
						<ul className={"list-disc"}>
							<li className={"ml-8"}>Updated Map images to match current Season.</li>
							<li className={"ml-8"}>
								You can now switch the current color of Pencil, Wards, Shapes and
								Text with the buttons "R" and "B".
							</li>
						</ul>
					</div>
					<div>
						<div className={"flex items-center gap-2 mb-2"}>
							<h1 className={"font-bold text-2xl"}>Version 1.1.0</h1>
						</div>
						<img
							src={map_110}
							alt={"A screenshot showing the new map"}
							className={
								"overflow-hidden rounded border border-black m-2 w-10/12 align-middle"
							}
						/>
						<ul className={"list-disc"}>
							<li className={"ml-8"}>New Noxus map images</li>
							<li className={"ml-8"}>
								Added Positional support for Atakhan (type does not work)
							</li>
							<li className={"ml-8"}>Fix for respawning Nexus towers</li>
						</ul>
					</div>
					<div>
						<div className={"flex items-center gap-2 mb-2"}>
							<h1 className={"font-bold text-2xl"}>Version 1.0.8</h1>
						</div>
						<img
							src={pencil_108}
							alt={"A screenshot showing the text functionality"}
							className={
								"overflow-hidden rounded border border-black m-2 w-6/12 align-middle"
							}
						/>
						<ul className={"list-disc"}>
							<li className={"ml-8"}>Line and arrows are now under the same tool</li>
							<li className={"ml-8"}>
								You can now load Flex Q games from the import modal
							</li>
							<li className={"ml-8"}>Images have been optimized to load faster</li>
						</ul>
					</div>
					<div>
						<div className={"flex items-center gap-2 mb-2"}>
							<h1 className={"font-bold text-2xl"}>Version 1.0.0</h1>
						</div>
						<img
							src={text_047}
							alt={"A screenshot showing the text functionality"}
							className={
								"overflow-hidden rounded border border-black m-2 w-10/12 align-middle"
							}
						/>
						<ul className={"list-disc"}>
							<li className={"ml-8"}>LoLPlanner is officially out of Beta!</li>
							<li className={"ml-8"}>
								You can now import GRID games with ward placements and 5 second
								frame resolution!
							</li>
						</ul>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export { ChangelogModal };
